import React from "react";
import { Container } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import { useMobile } from "../hooks/isMobile.tsx";

const RefundsPolicy = () => {
    const { isMobile } = useMobile();
    return (
        <>
            <Seo
                title="Refund Policy | FinQ India"
                description="FinQ India's refund policy for paid subscription plans — eligibility, timelines, and how to request a refund from Konsri Technologies Private Limited."
                path="/refunds-policy"
            />
            <Header />
            <Container
                width="min(calc(100% - 40px) , 900px)"
                justifyContent="center"
                margin="20px auto"
                column
                gap={"20px"}
            >
                        <Typography
                            tag="h1"
                            fontFamily="Neue Montreal"
                            fontSize={"28px"}
                            fontWeight={500}
                            lineHeight={"36.4px"}
                            letterSpacing={"0.02em"}
                            color="#202020"
                        >
                            Refund Policy — FinQ India
                        </Typography>

                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={400}
                            lineHeight={"27px"}
                            letterSpacing={"0.02em"}
                            color="#828282"
                        >
                    Thank you for choosing FinQ India.

                    Please read this Refund Policy carefully before making any purchase. By completing a payment on our platform, you acknowledge and agree to the terms outlined below.
                </Typography>

                        <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={500}
                            lineHeight={"36.4px"}
                            letterSpacing={"0.02em"}
                            color="#202020"
                        >
                            No Refund Policy
                        </Typography>
                        <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={400}
                            lineHeight={"27px"}
                            letterSpacing={"0.02em"}
                            color="#828282"
                        >
                            All payments made to FinQ India are <span style={{ fontWeight: 500, color:"#202020" }}>non-refundable</span>. Once a payment is successfully processed, <span style={{ fontWeight: 500, color:"#202020" }}>we do not offer refunds</span>, whether partial or full, under any circumstances.
                        </Typography>

                        <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={500}
                            lineHeight={"36.4px"}
                            letterSpacing={"0.02em"}
                            color="#202020"
                        >
                            This includes, but is not limited to:
                        </Typography>

                                <Container gap="5px">
                                    <Container
                                        width="20px"
                                        height="20px"
                                        alignItems="center"
                                        padding="1px 3px"
                                        radius="10px"
                                        justifyContent="center"
                                    >
                                        <Container width="12px" height="12px" radius="50%" background="#828282" />
                                    </Container>
                                    <Typography
                                        tag="p"
                                        fontFamily="Neue Montreal"
                                        fontSize={"16px"}
                                        fontWeight={500}
                                        lineHeight={"20.8px"}
                                        letterSpacing={"0.02em"}
                                        color="#202020"
                                    >
                                        Subscription fees
                                    </Typography>
                                </Container>

                                <Container gap="5px">
                                    <Container
                                        width="20px"
                                        height="20px"
                                        alignItems="center"
                                        padding="1px 3px"
                                        radius="10px"
                                        justifyContent="center"
                                    >
                                        <Container width="12px" height="12px" radius="50%" background="#828282" />
                                    </Container>
                                    <Typography
                                        tag="p"
                                        fontFamily="Neue Montreal"
                                        fontSize={"16px"}
                                        fontWeight={500}
                                        lineHeight={"20.8px"}
                                        letterSpacing={"0.02em"}
                                        color="#202020"
                                    >
                                        Plan upgrades or renewals
                                    </Typography>
                                </Container>

                                <Container gap="5px">
                                    <Container
                                        width="20px"
                                        height="20px"
                                        alignItems="center"
                                        padding="1px 3px"
                                        radius="10px"
                                        justifyContent="center"
                                    >
                                        <Container width="12px" height="12px" radius="50%" background="#828282" />
                                    </Container>
                                    <Typography
                                        tag="p"
                                        fontFamily="Neue Montreal"
                                        fontSize={"16px"}
                                        fontWeight={500}
                                        lineHeight={"20.8px"}
                                        letterSpacing={"0.02em"}
                                        color="#202020"
                                    >
                                        One-time purchases
                                    </Typography>
                                </Container>

                                <Container gap="5px">
                                    <Container
                                        width="20px"
                                        height="20px"
                                        alignItems="center"
                                        padding="1px 3px"
                                        radius="10px"
                                        justifyContent="center"
                                    >
                                        <Container width="12px" height="12px" radius="50%" background="#828282" />
                                    </Container>
                                    <Typography
                                        tag="p"
                                        fontFamily="Neue Montreal"
                                        fontSize={"16px"}
                                        fontWeight={500}
                                        lineHeight={"20.8px"}
                                        letterSpacing={"0.02em"}
                                        color="#202020"
                                    >
                                        Promotional or discounted plans
                                    </Typography>
                                </Container>

                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={400}
                            lineHeight={"27px"}
                            letterSpacing={"0.02em"}
                            color="#828282"
                        >
                    We strongly encourage users to make use of the <span style={{ fontWeight: 500, color:"#202020" }}> trial period</span>, explore our features, and evaluate the platform before purchasing any paid plan.
                </Typography>

            

                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={500}
                            lineHeight={"36.4px"}
                            letterSpacing={"0.02em"}
                            color="#202020"
                        >
                    Payment Errors
                </Typography>
                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={400}
                            lineHeight={"27px"}
                            letterSpacing={"0.02em"}
                            color="#828282"
                        >
                    If you believe a payment was made in error—such as duplicate charges or technical issues—please contact us immediately. While subscription fees are non-refundable, we may assist in resolving genuine payment processing mistakes.
                </Typography>

                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={500}
                            lineHeight={"36.4px"}
                            letterSpacing={"0.02em"}
                            color="#202020"
                        >
                    Contact Us
                </Typography>
                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={400}
                            lineHeight={"27px"}
                            letterSpacing={"0.02em"}
                            color="#828282"
                        >
                    If you have any questions regarding this policy, feel free to reach out to our support team at:
                </Typography>

                <Typography
                            tag="p"
                            fontFamily="Neue Montreal"
                            fontSize={"18px"}
                            fontWeight={500}
                            lineHeight={"36.4px"}
                            letterSpacing={"0.02em"}
                            color="#202020"
                        >
                    info@konsritech.com
                </Typography>
            </Container>
        </>
    );
};

export default RefundsPolicy;
